module.exports = __webpack_public_path__ + "media/images/web_suite/icon_labs-64cdffecbd2b12276ccbd6830e72fda4.png";